<template>
    <ul class="buttTab">
        <li class="p-pointer" v-for="(item,index) in tabList" :key="index" @click="tabClick(index)" :class="{active:tabIndex==index}">{{item.label}}</li>
    </ul>
</template>
<script>
export default {
    data(){
        return {
            // tabIndex:0,
        }
    },
    props:{
        tabList:{
            type:[Array],
            default:function(){
                return [];
            }
        },
        tabIndex:{
            type:[Number,String],
            default:0,
        }
    },
    methods:{
        tabClick(index){
            // this.tabIndex=index;
            this.$emit('tabChange',index)
        }
    }
}
</script>
<style lang="less" scoped>
.buttTab{
    display: flex;
    li{
        width:107px;
        height:36px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(234,234,243,1);
        opacity:1;
        border-radius:3px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 50px;
    }
    .active{
        background:#4D8EF6;
        border:1px solid #4D8EF6;
        color: #ffffff;
    }
}
</style>